import styled from 'styled-components';
import { Card, Input, token } from '@bynder/design-system';

export const BrowseInput = styled(Input)`
    input {
        width: 154px !important;
        box-sizing: border-box;
    }
`;

export const CardFrame = styled(Card.Frame)<{ isDisabled?: boolean }>`
    opacity: ${({ isDisabled }) => (isDisabled ? 0.65 : 'unset')};
`;

export const CardContextActionWrapper = styled.div`
    position: absolute;
    top: ${token.spacing4};
    left: ${token.spacing4};
    z-index: 1;
`;
